import { Component, EventEmitter, Input, OnChanges, Output } from "@angular/core";

const MIN_ZOOM = 0.5;
const MAX_ZOOM = 3;
const ZOOM_STEP = 0.25;
const DEFAULT_ZOOM = 1;

@Component({
  selector: "app-fax-zoom-modal",
  templateUrl: "./fax-zoom-modal.component.html",
  styleUrls: ["./fax-zoom-modal.component.scss"],
})
export class FaxZoomModalComponent implements OnChanges {
  @Input() isOpen = false;
  @Input() faxFileSrc = "";
  @Input() faxFilePage = 1;

  @Output() close = new EventEmitter<void>();

  zoom = DEFAULT_ZOOM;

  get zoomPercent() {
    return Math.round(this.zoom * 100);
  }

  get canZoomIn() {
    return this.zoom < MAX_ZOOM;
  }

  get canZoomOut() {
    return this.zoom > MIN_ZOOM;
  }

  ngOnChanges() {
    if (!this.isOpen) {
      this.zoom = DEFAULT_ZOOM;
    }
  }

  zoomIn() {
    this.zoom = Math.min(MAX_ZOOM, this.zoom + ZOOM_STEP);
  }

  zoomOut() {
    this.zoom = Math.max(MIN_ZOOM, this.zoom - ZOOM_STEP);
  }
}
